<template>
  <div>
    <h1>My Lists</h1>
    <div v-for="(list, index) in lists" :key="index">
      <router-link :to="'/watchlist/list/' + list.id">
        <div
          style="
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #ccc;
            padding: 8px;
            margin: 5px 0px;
            color: black;
            cursor: pointer;
          "
        >
          <!-- -->
          <div>
            <div>{{ list.name || 'List sin nombre' }}</div>
            <div style="color: rgba(0, 0, 0, 0.6)">
              {{ list.description }}
            </div>
          </div>
          <div>{{ list.items.length }} items</div>
        </div>
      </router-link>
    </div>

    <!--add button-->
    <v-fab-transition>
      <v-btn fab bottom right fixed color="success" @click="addList" :loading="loading" style="margin-bottom: 56px">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
import api from '@/assets/api'
import { v4 as uuidv4 } from 'uuid'
export default {
  data() {
    return { loading: false, lists: [] }
  },
  methods: {
    async addList() {
      const id = uuidv4()
      await api.apiFetch('/watchlistt/list', {
        method: 'POST',
        body: JSON.stringify({
          id,
          name: 'Nueva lista',
          description: 'Lista creada ' + new Date().toISOString(),
        }),
      })
      this.fetchData()
    },
    async fetchData() {
      //TODO
      this.loading = true
      this.lists = []
      let x = await api.apiFetch('/watchlistt/my-lists')

      if (x.ok) {
        let u = await x.json()
        const list_ids = u.lists
        for (let i = 0; i < list_ids.length; i++) {
          const id = list_ids[i]
          const y = await api.apiFetch('/watchlistt/list?id=' + id)

          if (y.ok) {
            let list_json = await y.json()
            this.lists.push(list_json)
          }
          console.log(u)
        }
      }
      this.loading = false
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped></style>
